<div *ngIf="flagLoading">
    <div class="container">
        <div class="row pt-5 pb-5">
            <div class="col-sm-8">              
                <p class="titleMicrositio fontMS300">
                    {{fichaModal.response.list[0].temaDesc}} - {{fichaModal.response.list[0].titleSeccion}}
                </p>
            </div>
            <div class="col-sm-12">               
                <div class="row">
                    <div class="col-sm-8">
                        <p class="titleDocumental fontMS700">
                            {{fichaModal.response.list[0].titulo}}
                        </p>
                    </div>
                    <div class="col-sm-4 ">
                        <!-- <p class="text-right">
                            <img id="sharePic" width="150px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">

                        </p> -->
                        <a (click)="test.toggle()" mdbWavesEffect>
                            <img width="150px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
                        </a>
                        <div mdbCollapse #test="bs-collapse">
                            <div class="divShared">
                                &nbsp;
                                &nbsp;
                                <a href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fficha/{{idDocumental}}" target="_blank">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                                </a>&nbsp;
                                <a href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fficha/{{idDocumental}}" target="_blank">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                                </a>&nbsp;
                                <a href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fficha/{{idDocumental}}" target="_blank">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 mt-1">
                        
                    </div>
                </div>
            </div>
            <div class="col-sm-12 divDivisor pb-4"> 
            </div>
            <div class="col-sm-4"> 
                <img id="sharePic"   width="100%" src="https://repombd.bnp.gob.pe/bnp/portadas/{{fichaModal.response.list[0].url_imagen_libro}}">

            </div>
            <div class="col-sm-4"> 
                <div class="textDescription fontMS100">
                    {{fichaModal.response.list[0].descripcion}}
                </div>
            </div>
            <div class="col-sm-4"> 
                <p class="fontMS500Italic verDoc">
                    Ver Documento
                </p>
               

                <div class="divDivisor pb-3">

                </div>
                <p class="mb-5">
                    <a (click)="abrirVisor()" title="Ver Documento">
                        <i class="far fa-file iconVerDoc"></i>

                    </a>
                    &nbsp;&nbsp;&nbsp;
                   
                  
                    
                </p>
                <p *ngIf="flagReproductor" class="fontMS500Italic verDoc">Escuchar pista de audio </p>
                <div *ngIf="flagReproductor" class="divDivisor pb-3"></div>
                <div *ngIf="flagReproductor">
                    <audio (contextmenu)="onRightClick()" controls controlsList="nodownload">
                        <source src="/assets/audios/musicaAndina/{{fichaModal.response.list[0].id_documental}}.mp3" type="audio/mpeg">
                      Your browser does not support the audio element.
                    </audio>
                </div>
                <p>
                    <br><br><br><br>
                </p>
                <p>
                    Otros documentos relacionados
                </p>
                <div class="divDivisor pb-5">
                    <br>
                <p *ngFor="let fichaRel of fichaModalRela.response.list">
                  <a class="relaFicha"  [routerLink]="['/ficha',fichaRel.id_documental]"> {{fichaRel.titulo}}</a>
                </p>
            </div>
        </div>
    </div>
</div>